var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-2"},[_c('router-link',{staticClass:"link footer-link  d-text d-s",attrs:{"to":"login"}},[_c('i',{staticClass:"tim-icons icon-minimal-left"}),_vm._v(" "+_vm._s(_vm.$t("resetPassword.backToLogin"))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }